"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportReasonId = exports.ReportReason = void 0;
/* eslint-disable */
const safety_reason_id_1 = require("./reason-id/safety_reason_id");
const store_item_reason_id_1 = require("./reason-id/store_item_reason_id");
const cameos_reason_id_1 = require("./reason-id/cameos_reason_id");
const generative_content_reason_id_1 = require("./reason-id/generative_content_reason_id");
const lens_reason_id_1 = require("./reason-id/lens_reason_id");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** DEPRECATED - Deprecated in favor of ReportReasonId */
var ReportReason;
(function (ReportReason) {
    /** REASON_UNSET - Default report reason for unset reasons */
    ReportReason[ReportReason["REASON_UNSET"] = 0] = "REASON_UNSET";
    /** DONT_LIKE_WANT_TO_SEE - Reporter does not like or want to see the reported data */
    ReportReason[ReportReason["DONT_LIKE_WANT_TO_SEE"] = 1] = "DONT_LIKE_WANT_TO_SEE";
    /** IMPERSONATION_FIRST_PERSON - Reported data is impersonating the reporter self */
    ReportReason[ReportReason["IMPERSONATION_FIRST_PERSON"] = 2] = "IMPERSONATION_FIRST_PERSON";
    /** IMPERSONATION_GENERAL - Reported data is impersonating others in general */
    ReportReason[ReportReason["IMPERSONATION_GENERAL"] = 3] = "IMPERSONATION_GENERAL";
    /**
     * SPAM_FIRST_PERSON - Reported data is spamming the reporter self
     *  For user reports, this includes the reported user being annoying
     *  or spamming the reporter with friend requests or abusive contents
     */
    ReportReason[ReportReason["SPAM_FIRST_PERSON"] = 4] = "SPAM_FIRST_PERSON";
    /** SPAM_GENERAL - Reported data is general unsolicited spam */
    ReportReason[ReportReason["SPAM_GENERAL"] = 5] = "SPAM_GENERAL";
    /** SPAM_FRIEND_REQUEST - Reported data is related to spamming friend requests */
    ReportReason[ReportReason["SPAM_FRIEND_REQUEST"] = 35] = "SPAM_FRIEND_REQUEST";
    /** SPAM_CREEPY - Reported data is creepy or annoying spam */
    ReportReason[ReportReason["SPAM_CREEPY"] = 36] = "SPAM_CREEPY";
    /**
     * HATE_SPEECH_GENERAL - reserved 6; // Reserved for HATE_SPEECH_FIRST_PERSON
     * Reported data contains general hate speech against others
     */
    ReportReason[ReportReason["HATE_SPEECH_GENERAL"] = 7] = "HATE_SPEECH_GENERAL";
    /**
     * VIOLENT_DISTURBING_GENERAL - reserved 8; // Reserved for VIOLENT_DISTURBING_FIRST_PERSON
     * Reported data contains general violent or disturbing content
     */
    ReportReason[ReportReason["VIOLENT_DISTURBING_GENERAL"] = 9] = "VIOLENT_DISTURBING_GENERAL";
    /** THREAT_THREATENING_FIRST_PERSON - Reported data is a threat or threatening the reporter self */
    ReportReason[ReportReason["THREAT_THREATENING_FIRST_PERSON"] = 10] = "THREAT_THREATENING_FIRST_PERSON";
    /** THREAT_THREATENING_GENERAL - Reported data is a threat or threatening others in general */
    ReportReason[ReportReason["THREAT_THREATENING_GENERAL"] = 11] = "THREAT_THREATENING_GENERAL";
    /** THREAT_SEXTORTION - Reported data contains a sextortion threat */
    ReportReason[ReportReason["THREAT_SEXTORTION"] = 37] = "THREAT_SEXTORTION";
    /** INAPPROPRIATE_FIRST_PERSON - Reported data contains inappropriate content of the reporter self */
    ReportReason[ReportReason["INAPPROPRIATE_FIRST_PERSON"] = 12] = "INAPPROPRIATE_FIRST_PERSON";
    /** INAPPROPRIATE_PROMOTION - Reported data explicitly promotes inappropriate content */
    ReportReason[ReportReason["INAPPROPRIATE_PROMOTION"] = 25] = "INAPPROPRIATE_PROMOTION";
    /** INAPPROPRIATE_GENERAL - Reported data contains inappropriate content in general */
    ReportReason[ReportReason["INAPPROPRIATE_GENERAL"] = 13] = "INAPPROPRIATE_GENERAL";
    /** INAPPROPRIATE_LENS - Reported data contains an inappropriate lens */
    ReportReason[ReportReason["INAPPROPRIATE_LENS"] = 14] = "INAPPROPRIATE_LENS";
    /** INAPPROPRIATE_ATTACHMENT - Reported data contains an inappropriate attachment (url) */
    ReportReason[ReportReason["INAPPROPRIATE_ATTACHMENT"] = 15] = "INAPPROPRIATE_ATTACHMENT";
    /** INAPPROPRIATE_CHILD - Reported data contains an inappropriate child content */
    ReportReason[ReportReason["INAPPROPRIATE_CHILD"] = 30] = "INAPPROPRIATE_CHILD";
    /** BULLYING_HARASSMENT_FIRST_PERSON - Reported data is bullying or harassing the reporter self */
    ReportReason[ReportReason["BULLYING_HARASSMENT_FIRST_PERSON"] = 16] = "BULLYING_HARASSMENT_FIRST_PERSON";
    /** BULLYING_HARASSMENT_GENERAL - Reported data is bullying or harassing others in general */
    ReportReason[ReportReason["BULLYING_HARASSMENT_GENERAL"] = 17] = "BULLYING_HARASSMENT_GENERAL";
    /** BULLYING_HARASSMENT_SEXUAL - Reported data is related to sexual harassment */
    ReportReason[ReportReason["BULLYING_HARASSMENT_SEXUAL"] = 34] = "BULLYING_HARASSMENT_SEXUAL";
    /** PRIVACY_INVASION_FIRST_PERSON - Report data is an invasion of privacy for the reporter self */
    ReportReason[ReportReason["PRIVACY_INVASION_FIRST_PERSON"] = 18] = "PRIVACY_INVASION_FIRST_PERSON";
    /** SELF_HARM_SUICIDE - Reported data contains self harm or suicide content of others */
    ReportReason[ReportReason["SELF_HARM_SUICIDE"] = 20] = "SELF_HARM_SUICIDE";
    /** SELF_HARM_SUICIDE_PROMOTE - Reported data contains promotion of self harm or suicide content */
    ReportReason[ReportReason["SELF_HARM_SUICIDE_PROMOTE"] = 31] = "SELF_HARM_SUICIDE_PROMOTE";
    /** TERRORISM_EXTREMISM - Reported data contains terrorism and extremism content in general */
    ReportReason[ReportReason["TERRORISM_EXTREMISM"] = 21] = "TERRORISM_EXTREMISM";
    /** FRAUDULENT_INFORMATION - Reported data contains fraudulent information content in general */
    ReportReason[ReportReason["FRAUDULENT_INFORMATION"] = 22] = "FRAUDULENT_INFORMATION";
    /** FRAUDULENT_INFORMATION_POLITICS - Reported data contains fraudulent information on politics */
    ReportReason[ReportReason["FRAUDULENT_INFORMATION_POLITICS"] = 27] = "FRAUDULENT_INFORMATION_POLITICS";
    /** FRAUDULENT_INFORMATION_HEALTH - Reported data contains fraudulent information on health */
    ReportReason[ReportReason["FRAUDULENT_INFORMATION_HEALTH"] = 28] = "FRAUDULENT_INFORMATION_HEALTH";
    /** FRAUDULENT_INFORMATION_SOCIAL_ISSUES - Reported data contains fraudulent information on social issues */
    ReportReason[ReportReason["FRAUDULENT_INFORMATION_SOCIAL_ISSUES"] = 29] = "FRAUDULENT_INFORMATION_SOCIAL_ISSUES";
    /** DRUG_SALE_USE - Reported data contains sales or user of drugs in general */
    ReportReason[ReportReason["DRUG_SALE_USE"] = 23] = "DRUG_SALE_USE";
    /** WEAPON_SALE_USE - Reported data contains sales or user of weapons in general */
    ReportReason[ReportReason["WEAPON_SALE_USE"] = 24] = "WEAPON_SALE_USE";
    /** UNDER_THIRTEEN - Reported data contains user or content of under 13 years old */
    ReportReason[ReportReason["UNDER_THIRTEEN"] = 26] = "UNDER_THIRTEEN";
    /** COUNTERFEIT_GOODS - Reported data contains content or promotion of counterfeit goods */
    ReportReason[ReportReason["COUNTERFEIT_GOODS"] = 32] = "COUNTERFEIT_GOODS";
    /** FEATURE_BROKEN - Reported data contains report of a feature that does not work as expected. */
    ReportReason[ReportReason["FEATURE_BROKEN"] = 33] = "FEATURE_BROKEN";
    /** ILLEGAL_GENERAL - Reported data is for general illegal reasons */
    ReportReason[ReportReason["ILLEGAL_GENERAL"] = 38] = "ILLEGAL_GENERAL";
    /** REPORT_SNAPGRAPH_ESCALATION - Reported data is for snapgraph escalation */
    ReportReason[ReportReason["REPORT_SNAPGRAPH_ESCALATION"] = 39] = "REPORT_SNAPGRAPH_ESCALATION";
    ReportReason[ReportReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ReportReason = exports.ReportReason || (exports.ReportReason = {}));
function createBaseReportReasonId() {
    return { reasonId: undefined };
}
exports.ReportReasonId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reasonId?.$case === "safetyReasonId") {
            safety_reason_id_1.SafetyReasonId.encode(message.reasonId.safetyReasonId, writer.uint32(10).fork()).ldelim();
        }
        if (message.reasonId?.$case === "storeItemReasonId") {
            store_item_reason_id_1.StoreItemReasonId.encode(message.reasonId.storeItemReasonId, writer.uint32(18).fork()).ldelim();
        }
        if (message.reasonId?.$case === "cameosReasonId") {
            cameos_reason_id_1.CameosReasonId.encode(message.reasonId.cameosReasonId, writer.uint32(26).fork()).ldelim();
        }
        if (message.reasonId?.$case === "generativeContentReasonId") {
            generative_content_reason_id_1.GenerativeContentReasonId.encode(message.reasonId.generativeContentReasonId, writer.uint32(34).fork()).ldelim();
        }
        if (message.reasonId?.$case === "lensReasonId") {
            lens_reason_id_1.LensReasonId.encode(message.reasonId.lensReasonId, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReportReasonId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reasonId = {
                        $case: "safetyReasonId",
                        safetyReasonId: safety_reason_id_1.SafetyReasonId.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.reasonId = {
                        $case: "storeItemReasonId",
                        storeItemReasonId: store_item_reason_id_1.StoreItemReasonId.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.reasonId = {
                        $case: "cameosReasonId",
                        cameosReasonId: cameos_reason_id_1.CameosReasonId.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.reasonId = {
                        $case: "generativeContentReasonId",
                        generativeContentReasonId: generative_content_reason_id_1.GenerativeContentReasonId.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.reasonId = {
                        $case: "lensReasonId",
                        lensReasonId: lens_reason_id_1.LensReasonId.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseReportReasonId();
        if (object.reasonId?.$case === "safetyReasonId" &&
            object.reasonId?.safetyReasonId !== undefined &&
            object.reasonId?.safetyReasonId !== null) {
            message.reasonId = {
                $case: "safetyReasonId",
                safetyReasonId: safety_reason_id_1.SafetyReasonId.fromPartial(object.reasonId.safetyReasonId),
            };
        }
        if (object.reasonId?.$case === "storeItemReasonId" &&
            object.reasonId?.storeItemReasonId !== undefined &&
            object.reasonId?.storeItemReasonId !== null) {
            message.reasonId = {
                $case: "storeItemReasonId",
                storeItemReasonId: store_item_reason_id_1.StoreItemReasonId.fromPartial(object.reasonId.storeItemReasonId),
            };
        }
        if (object.reasonId?.$case === "cameosReasonId" &&
            object.reasonId?.cameosReasonId !== undefined &&
            object.reasonId?.cameosReasonId !== null) {
            message.reasonId = {
                $case: "cameosReasonId",
                cameosReasonId: cameos_reason_id_1.CameosReasonId.fromPartial(object.reasonId.cameosReasonId),
            };
        }
        if (object.reasonId?.$case === "generativeContentReasonId" &&
            object.reasonId?.generativeContentReasonId !== undefined &&
            object.reasonId?.generativeContentReasonId !== null) {
            message.reasonId = {
                $case: "generativeContentReasonId",
                generativeContentReasonId: generative_content_reason_id_1.GenerativeContentReasonId.fromPartial(object.reasonId.generativeContentReasonId),
            };
        }
        if (object.reasonId?.$case === "lensReasonId" &&
            object.reasonId?.lensReasonId !== undefined &&
            object.reasonId?.lensReasonId !== null) {
            message.reasonId = {
                $case: "lensReasonId",
                lensReasonId: lens_reason_id_1.LensReasonId.fromPartial(object.reasonId.lensReasonId),
            };
        }
        return message;
    },
};
//# sourceMappingURL=report_reason.js.map